import { FgpEveriLaunchData } from '@/features/providers/everi/types';

export const buildEveriUrl = (input: FgpEveriLaunchData): string =>
  input.launchDetails.url;
